import Axios from "axios";
import router from "@/router";
import store from "@/store";
import { message, Modal } from "ant-design-vue";
import commonConfig from "@/config/common-config.js";
const { XXTEA } = require("@/common/encrypt/XXTEA.js");
require("@/common/encrypt/base64.js");
require("@/common/encrypt/des.js");
const qs = require("qs");

Axios.interceptors.request.use(
  function(config) {
    //发送请求之前做某事
    // 添加取消标记
    window.axiosCancel = [];
    config.cancelToken = new Axios.CancelToken(cancel => {
      window.axiosCancel.push({ cancel });
    });
    return config;
  },
  function(error) {
    //请求错误时
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

const strEnc = function(value,noEncryptParam2) {
  if (!commonConfig.config.encryptParam) {
    return value;
  }
  if (value) {
    value = typeof(value) == "object" ? JSON.stringify(value) : String(value)
    switch (commonConfig.config.algorithm) {
      case "XXTEA":
        value = XXTEA.encryptToBase64(
          value,
          commonConfig.config.pubKey
        );
        break;
      case "des":
        value = window.strEnc(value, commonConfig.config.pubKey);
        break;
      case "base64":
        value = window.BASE64.encoder(value);
        break;
      default:
        value = XXTEA.encryptToBase64(
          value,
          commonConfig.config.pubKey
        );
    }
  }
  return value;
};
const paramsFormat = function(params) {
  let resParams = {};
  for (let i in params) {
    let val = params[i];
    if (Array.isArray(val) && val.length > 0) {
      resParams[i] = val;
    } else if (val && typeof val === "object" && JSON.stringify(val) != "{}") {
      resParams[i] = val;
    } else if (val || val === 0 ) {
      resParams[i] = val;
    }
  }
  return resParams;
};
const axios = function({
  responseType,
  url,
  data = null, //参数，post、get
  type = "post",
  isTransform = true, //是否过滤参数
  loading = false,
  success = null, //成功回调函数，为空时走统一处理
  fail = null, //失败回调函数，为空时走统一处理
  noFailMsg = false, //是否提示错误信息
  noEncryptParam = false, //可单独设置接口参数是否加密
  contentType = "application/x-www-form-urlencoded",
  cache
}) {
  return new Promise((resolve, reject) => {
    // console.log("参数：",JSON.parse(JSON.stringify(data)))
    if (loading) {
      store.commit("home/setLoadMainStatus", true);
    }

    if (data && isTransform) {
      //处理空参数
      data = paramsFormat(data);
    }

    for (var key in data) {
      //参数加蜜
      data[key] =
        noEncryptParam || type == "get" ? data[key] : (contentType == 'application/json' ? strEnc(data[key]) : strEnc(String(data[key])));
    }

    const whenOk = res => {
      if (loading) {
        store.commit("home/setLoadMainStatus", false);
      }

      // if(noFailMsg){
      //   resolve(res.data);
      //   return;
      // }
      if (success) {
        if(typeof success == 'function'){
          success(res.data);
        }
        resolve(res.data);
        return;
      }
      if (res.data.status == 200 || res.data.status == 304 || res.code == 200) {
        resolve(res.data);
      } else if (res.data.status == 401) {
        message.warn("登录失效，请重新登录");
        router.push({ path: "/login" });
        if (window.sessionStorage) {
          window.sessionStorage.removeItem("ACTIVEPATH");
          window.sessionStorage.removeItem("ACTIVETABBAR");
          window.sessionStorage.removeItem("OPENEDTABBAR");
          window.localStorage.removeItem("CURRENTROLE");
        }
        reject(res.data);
      } else {
        reject(res.data);
        const msg = res.data.message || res.data.description;
        if (msg && !noFailMsg) {
          message.error({
            content: msg,
            duration: 4
          });
        }
      }

    };
    const whenErr = err => {
      if (loading) {
        store.commit("home/setLoadMainStatus", false);
      }
      if (err.message == "cancel") {
        console.log("请求取消");
        return;
      }
      if (fail && err.message != "cancel") {
        fail(err);
        reject(err);
        return;
      }
      message.error("网络请求失败，请检查网络");
      reject(err);
    };

    // 文件上传等不使用baseUrl
    let baseUrl = process.env.VUE_APP_BASE_API || "";
    if (url.indexOf("/gb-bigtree-file") > -1) {
      baseUrl = "";
    }
    Axios({
      responseType,
      method: type,
      url: baseUrl + url,
      data: type == "post" ? data : null,
      params: type == "get" ? data : null,
      transformRequest: [
        function(data, headers) {
          // 对 data 进行任意转换处理
          if (isTransform && headers["Content-Type"] != "application/json") {
            data = qs.stringify(data);
          }
          return data;
        },
        ...Axios.defaults.transformRequest
      ],
      headers: {
        "Content-Type": contentType,
        'Cache-Control': cache
      }
    })
      .then(whenOk)
      .catch(whenErr);
  });
};
export default {
  axios
};



// WEBPACK FOOTER //
// ./src/axios/index.js